import React, { FC, useState, useEffect, Suspense } from 'react';
import { Spinner } from '@scale/scaleui';
import apiFetch, { handleApiFetchError } from 'react-scale/lib/api-fetch';
import {
  IndexedInteractionStepResponse,
  MultiTurnInteractionConfiguration,
} from '@scale/shared/types/chat';
import { IChatTaskFeatureConfig } from '@scale/shared/types/config';
import { ReviewLevel } from '@scale/shared/defaults';

const ChatPreview = React.lazy(
  () => import('react-scale/corp/components/QM/taskTemplatesEditor/ChatPreview'),
);

interface ChatTaskReadOnlyProps {
  projectId?: string;
  taskId: string;
}

export const ChatTaskReadOnly: FC<ChatTaskReadOnlyProps> = ({ projectId, taskId }) => {
  const [params, setParams] = useState<MultiTurnInteractionConfiguration>();
  const [responses, setResponses] = useState<IndexedInteractionStepResponse[]>();
  const [chatTaskFeatureConfig, setChatTaskFeatureConfig] = useState<IChatTaskFeatureConfig>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [reviewLevel, setReviewLevel] = useState<ReviewLevel>();

  // Get chat task from BE & set data state.
  async function getChatPromptAndResponses(taskId: string) {
    setIsLoading(true);
    try {
      const {
        params: taskParams,
        responses: taskResponses,
        chatTaskFeatureConfig,
        reviewLevel,
      } = await apiFetch(null, `internal/courses/chat-preview-content/${taskId}`);
      if (taskParams && taskResponses) {
        setParams(taskParams);
        setResponses(taskResponses);
        setReviewLevel(reviewLevel);
        setChatTaskFeatureConfig(chatTaskFeatureConfig);
      }
    } catch (e) {
      handleApiFetchError(e, 'Failed to fetch ChatPromptAndResponses');
    }

    setIsLoading(false);
  }

  useEffect(() => {
    getChatPromptAndResponses(taskId);
  }, [taskId]);

  return (
    <div className="scaleui scale-theme scale-tailwind">
      {isLoading ? (
        <Spinner size={'md'} className="m-4" />
      ) : (
        params &&
        responses && (
          <Suspense fallback={<Spinner size="md" className="m-4" />}>
            <ChatPreview
              params={params}
              responses={responses}
              reviewLevel={reviewLevel}
              chatTaskFeatureConfig={chatTaskFeatureConfig}
              projectId={projectId}
              readOnly={true}
            />
          </Suspense>
        )
      )}
    </div>
  );
};
